
/**
 * @deprecated
 * use direct export from 'eskimos-ui' instead
 * TODO NDO: change all imports paths to refer to eskimos-ui instead of this file
 */
export { getClassNameGenerator } from '../../../libraries/eskimos-ui/utils/className';
